import { type ActivityItemEdge, isGraphActivity } from '@atlassian/search-client';

type RecentActivityItem = {
	id: string;
	type: string;
	data: ActivityItemEdge;
};

/**
 * Applies Top-N boosting to prioritize 3rd party graph activities.
 * Only boosts 3P activities that are already in the top N by recency to avoid surfacing stale content.
 *
 * @param activities - The deduplicated recent activities to process
 * @param remainingSlots - Number of slots available for recent activities
 * @param topN - The top N activities to consider for boosting (default: 7)
 * @returns Activities with 3P items prioritized, limited to remainingSlots
 */
export const applyThirdPartyBoosting = <T extends RecentActivityItem>(
	activities: T[],
	remainingSlots: number,
	topN: number = 7,
): T[] => {
	const topRecentActivities = activities.slice(0, topN);

	const thirdPartyActivities = topRecentActivities.filter((activity) =>
		isGraphActivity(activity.data.node.object),
	);
	const nonThirdPartyActivities = topRecentActivities.filter(
		(activity) => !isGraphActivity(activity.data.node.object),
	);

	return [...thirdPartyActivities, ...nonThirdPartyActivities].slice(0, remainingSlots);
};

